import _get from 'lodash/get';
import { Router } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import { LAYOUT_ENTITIES } from '@bedrock/fido-sdk';
import { Video } from '../video/video.component';
import connect from './live.connector';
import { getTopBarItems } from './live.utils';
import { TOP_BAR_ITEMS } from './live.constants';
import { reset } from '../../logic/player/player.constants';
import { fetchLayout } from '../../logic/layout/layout.actions';
import { switchToNextProgram, getNewMetadataItems } from '../../logic/player/player.actions';

export class Live extends Video {
  _active() {
    this._isOnLive = true;
    this._startTimeInSeconds = 0;
    this._startOverFeature = false;
    super._active();
  }

  _onUrlParams({ videoId }) {
    Store.dispatch(reset());
    Store.dispatch(fetchLayout(LAYOUT_ENTITIES.live, videoId));
  }

  _connect() {
    return connect(this);
  }

  set startOverFeature(value) {
    this._startOverFeature = value;
    this._updateTopBarItems();
  }

  set startTimeInSeconds(value) {
    this._startTimeInSeconds = value;
  }

  set isOnLive(value) {
    this._isOnLive = value;
    this._updateTopBarItems();
  }

  set shouldSwitchToNextProgram(value) {
    if (value) {
      Store.dispatch(switchToNextProgram());
    }
  }

  set shouldLoadNewMetadataItems(value) {
    if (value) {
      Store.dispatch(getNewMetadataItems());
    }
  }

  _pause() {
    // On live, pausing is only allowed when the start-over feature is enabled
    if (!this._startOverFeature) {
      return;
    }

    super._pause();
  }

  _updateTopBarItems() {
    this.tag('Controls').topBarItems = getTopBarItems({
      isOnLive: this._isOnLive,
      hasTracks: this._hasTracks,
      hasRelatedVideos: this._hasRelatedVideos,
      hasProgramInformation: this._hasProgramInformation,
      startOverFeature: this._startOverFeature,
    });
  }

  _handleSeek(position) {
    this.tag('Player').seek(this._startTimeInSeconds + position);
  }

  _handleTopBarItemSelection(item) {
    const id = _get(item, 'id', '');

    if (id === TOP_BAR_ITEMS.BACK) {
      Router.back();
    } else if (id === TOP_BAR_ITEMS.START_OVER) {
      this._handleStartOver();
    } else if (id === TOP_BAR_ITEMS.BACK_TO_LIVE) {
      this._handleBackToLive();
    } else if (id === TOP_BAR_ITEMS.TRACKS) {
      this.tag('Controls').showTracks();
    } else if (id === TOP_BAR_ITEMS.RELATED_VIDEOS) {
      this.tag('Controls').showSideGlass();
    } else if (id === TOP_BAR_ITEMS.INFO_PAGE) {
      this.tag('Controls').showProgramInformation();
    }
  }

  _handleStartOver() {
    this._handleSeek(0);
    this._play();
    this.isOnLive = false;
  }

  _handleBackToLive() {
    Store.dispatch(switchToNextProgram());
    this.tag('Player').backToLive();
    this.isOnLive = true;
  }
}
